export default "__VITE_ASSET__DX_b0aIr__"